__turbopack_context__.v({
  "actionButton": "PromptSelector-module__dcDfLG__actionButton",
  "button": "PromptSelector-module__dcDfLG__button",
  "buttonDisabled": "PromptSelector-module__dcDfLG__buttonDisabled",
  "container": "PromptSelector-module__dcDfLG__container",
  "fixedLabel": "PromptSelector-module__dcDfLG__fixedLabel",
  "generateButton": "PromptSelector-module__dcDfLG__generateButton",
  "icon": "PromptSelector-module__dcDfLG__icon",
  "iconWrapper": "PromptSelector-module__dcDfLG__iconWrapper",
  "input": "PromptSelector-module__dcDfLG__input",
  "inputContainer": "PromptSelector-module__dcDfLG__inputContainer",
  "labelInputContainer": "PromptSelector-module__dcDfLG__labelInputContainer",
  "previewContainer": "PromptSelector-module__dcDfLG__previewContainer",
  "previewText": "PromptSelector-module__dcDfLG__previewText",
  "previewValue": "PromptSelector-module__dcDfLG__previewValue",
  "searchBar": "PromptSelector-module__dcDfLG__searchBar",
  "searchContainer": "PromptSelector-module__dcDfLG__searchContainer",
  "searchInput": "PromptSelector-module__dcDfLG__searchInput",
  "searchWrapper": "PromptSelector-module__dcDfLG__searchWrapper",
  "suggestionCard": "PromptSelector-module__dcDfLG__suggestionCard",
  "suggestionText": "PromptSelector-module__dcDfLG__suggestionText",
  "suggestionsContainer": "PromptSelector-module__dcDfLG__suggestionsContainer",
  "suggestionsGrid": "PromptSelector-module__dcDfLG__suggestionsGrid",
  "suggestionsHeading": "PromptSelector-module__dcDfLG__suggestionsHeading",
  "title": "PromptSelector-module__dcDfLG__title",
});
